<template>
    <v-alert
        :value="alert.properties.value"
        :type="alert.properties.type"
        dismissible
    >
        There's a rule in your system that allows all users to use
        all connectors. Click <a @click="$emit('fix')">here</a> to go to the ACL section and fix it.
    </v-alert>
</template>

<script>
export default {
    name: 'UserACLAlert',

    props: {
        alert: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>

</style>
